import React from 'react'

import Box from 'components/Box'
import {
  FollowDropdown,
  FollowDropdownAction,
  FollowDropdownBellIcon,
  FollowDropdownChevronIcon,
  FollowDropdownContent,
  FollowDropdownDescription,
  FollowDropdownDivider,
  FollowDropdownLabel,
  FollowDropdownTrigger,
} from './SubscriptionToggle.styles'

import { Status, DocumentToggleProps } from './types'

import { useUpdateNotification } from './operations'

//-----------------------------------------------------------------------------
// CONSTANTS

export const labels: { [key in Status]: string } = {
  ON: 'Following this document',
  OFF: 'Not following this document',
  PARTIAL: 'Following some Artboards and threads',
} as const

export const actions: { [key in Status]: string } = {
  ON: 'Follow this Document',
  OFF: 'Stop Following Document',
  PARTIAL: 'Following some Artboards',
} as const

export const descriptions: { [key in Status]: string } = {
  ON: 'You will receive all notifications for this document',
  OFF: 'You will not receive any notifications for this document',
  PARTIAL: 'You will only receive notifications for some Artboards',
} as const

//-----------------------------------------------------------------------------
// COMPONENTS

export const DocumentSubscriptionToggle: React.FC<DocumentToggleProps> = ({
  status,
  id,
  versionShortId,
}) => {
  const { updateShareNotification } = useUpdateNotification()

  const handleOn = () => {
    updateShareNotification({ id, versionShortId, status: 'ON' })
  }

  const handleOff = () => {
    updateShareNotification({ id, versionShortId, status: 'OFF' })
  }

  return (
    <Box mt={5}>
      <FollowDropdown
        test-id="follow-dropdown"
        toggle={
          <FollowDropdownTrigger>
            <FollowDropdownBellIcon status={status} />
            <FollowDropdownLabel>{labels[status]}</FollowDropdownLabel>
            <FollowDropdownChevronIcon />
          </FollowDropdownTrigger>
        }>
        <FollowDropdownContent>
          <FollowDropdownDescription>
            {descriptions[status]}
          </FollowDropdownDescription>
          <FollowDropdownDivider />
          {status !== 'ON' && (
            <FollowDropdownAction onClick={handleOn}>
              {actions.ON}
            </FollowDropdownAction>
          )}
          {status !== 'OFF' && (
            <FollowDropdownAction onClick={handleOff}>
              {actions.OFF}
            </FollowDropdownAction>
          )}
        </FollowDropdownContent>
      </FollowDropdown>
    </Box>
  )
}
